import React, { Component } from 'react';
import styled from 'styled-components';
// import Button from '@vzrf/react-button';
import { Button } from '@vds/buttons';
import { connect } from 'react-redux'
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints } from '@vzrf/react-theme-helpers';
import * as modalAction from '../../../action/modalWindow';
import * as action from '../../../action/buildProduct';

import './FiosFive.scss'

const ModalContaier = styled.div`
    padding: ${calculateRem(0, 0, 20)};
    min-height: ${calculateRem(128)};

    @media only screen and (min-width: ${breakpoints.md}) {
        padding:${calculateRem(0, 0, 20)};
        min-height: ${calculateRem(128)};
    };
`;

const HeaderContainer = styled.div`
    margin: ${calculateRem(30, 20, 10)};
`;

const HeaderSubtitle = styled.p`
    font-size: 16px;
    font-weight: normal;
    line-height: 1.29;
    letter-spacing: 0.25px;
    color: #767676;
    margin: 0;
`;

const ModalHeader = (title, subTitle) => (
    <HeaderContainer>
        <div>
            <h2 className="margin-top-zero normal-weight">{title}</h2>
        </div>
        <div className="clear"></div>
        <HeaderSubtitle className="intlCallingRsknsub margin-bottom-xlarge">{subTitle}</HeaderSubtitle>
    </HeaderContainer>
);

const ButtonRow = styled.div`
    width: 100%;
    text-align: center;
    margin: ${calculateRem(20, 0)};

    @media only screen and (min-width: ${breakpoints.md}) {
        margin: ${calculateRem(33, 0)};
      };

    // & ${Button} {
    //     margin: 0;
    //     border-radius: 0;
    //     width: ${calculateRem(240)};
    //     border: 0;
    //     padding-top: ${calculateRem(14)};
    //     padding-bottom: ${calculateRem(14)};
    //     background: #333333;
    //     line-height: 1.25;
    //   }
    //   & ${Button}[disabled] {
    //     background: #b4b4b4;
    //   }
`;

const ReviewButtonRow = styled.div`
      text-align: center;
      margin: ${calculateRem(10, 0)};
      height: ${calculateRem(18)};
`;

const ReviewButton = styled.button`
    color: #398dfa;
    background: transparent;
    font-family: BrandFont-Text,Arial,sans-serif;
    font-size: .88rem!important;
    line-height: 1.14;
    border: 0;
    padding: 0;
    margin: 0;
    pointer: cursor;
`;


class FiosFiveExitChannel extends Component {
    constructor(props) {
        super(props);
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
    }
    pickChannelsAction = () => {
        action.setFiosFiveModalDetails('pickChannels', [], this.props.dispatch);
}
   
      notNowAction = () => {
        action.setFiosFiveModalDetails('intro',[], this.props.dispatch);
        modalAction.closeModalWindow('', this.props.dispatch);

      }

      componentDidMount(){
        //focus close button by default - accessibility
        let closeBtnEl = document.getElementsByClassName('styles_closeButton__20ID4');
        closeBtnEl && closeBtnEl.length && closeBtnEl[0].focus();
    }

    render() {
        const title = "You haven't completed your selection.";
        const subTitle = "You can always choose to upgrade to Fios TV Test Drive if you can't pick your five favorite channels right now.";
        return (            
            <React.Fragment>
                {/* <ModalContaier> */}
                {ModalHeader(title, subTitle)}
                {/* </ModalContaier>        */}
                <ButtonRow className="modalFooterButtonReskin2">
                    <Button onClick={this.pickChannelsAction}>Pick my channels</Button>
                    {this.isReskin && <Button secondary={true} onClick={this.notNowAction} className="Reskinsecondary modalFooterButtonReskin2">No thanks</Button>}
                </ButtonRow>

                {!this.isReskin && <ReviewButtonRow>
                    <ReviewButton onClick={this.notNowAction}>Not now, thanks</ReviewButton>
                </ReviewButtonRow>  }  
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        buildProductState: state.buildProduct,
    }
}
export default connect(
    mapStateToProps
)(FiosFiveExitChannel);